import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=74a9cda5&scoped=true"
import script from "./VideoManage.vue?vue&type=script&lang=js"
export * from "./VideoManage.vue?vue&type=script&lang=js"
import style0 from "./VideoManage.vue?vue&type=style&index=0&id=74a9cda5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a9cda5",
  null
  
)

export default component.exports